import { Link } from 'react-router-dom';
import { MessageSquare, Mail, Phone, Instagram, Twitter, Facebook } from 'lucide-react';
import { Button } from '@/components/ui/button';

const Footer = () => {
  return (
    <footer className="bg-black">
      {/* CTA Section */}
      <section className="py-16 px-10 bg-gradient-to-b from-black to-hotel-primary text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-2xl font-semibold mb-4">Need help or want a custom demo?</h2>
          <p className="text-md mb-8 max-w-2xl mx-auto text-gray-100">
            Contact us for a custom demo or help with your implementation.
          </p>
          <div className="flex flex-col sm:flex-row justify-center space-y-3 sm:space-y-0 sm:space-x-4">
            <Link to="/contact">
              <Button className="bg-white text-hotel-primary hover:bg-gray-100 w-full sm:w-auto font-semibold px-8 py-3">
                Start Free Trial
              </Button>
            </Link>
            <a href="https://lobier.com/demo/" target="_blank" rel="noopener noreferrer">
              <Button variant="outline" className="border-white bg-transparent text-white hover:bg-white hover:text-hotel-primary w-full sm:w-auto font-semibold px-8 py-3">
                See Demo
              </Button> 
            </a>
          </div>
        </div>
      </section>

      {/* Footer Content */}
      <div className="pb-10 md:pb-5">
        <div className='flex flex-col items-center text-center px-5 py-10 md:pt-20'>
          <Link to="/" className="flex items-center space-x-2">
            <MessageSquare className="h-6 w-6 text-[#03A05C]" />
            <span className="text-xl font-bold text-white">Lobier AI</span>
          </Link>
          <p className="mt-2 text-gray-300">
            AI-powered chat solution for hotels to enhance guest experience and boost engagement.
          </p>
        </div>
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 hidden">
            <div>
              <Link to="/" className="flex items-center space-x-2">
                <MessageSquare className="h-6 w-6 text-white" />
                <span className="text-xl font-bold">Lobier AI</span>
              </Link>
              
            </div>
            
            <div>
              <h3 className="text-lg font-semibold mb-4">Product</h3>
              <ul className="space-y-2">
                <li><Link to="/features" className="text-gray-300 hover:text-white transition-colors">Features</Link></li>
                <li><Link to="/pricing" className="text-gray-300 hover:text-white transition-colors">Pricing</Link></li>
                <li><Link to="/" className="text-gray-300 hover:text-white transition-colors">How it Works</Link></li>
              </ul>
            </div>
            
            <div>
              <h3 className="text-lg font-semibold mb-4">Company</h3>
              <ul className="space-y-2">
                <li><Link to="/" className="text-gray-300 hover:text-white transition-colors">About Us</Link></li>
                <li><Link to="/" className="text-gray-300 hover:text-white transition-colors">Careers</Link></li>
                <li><Link to="/" className="text-gray-300 hover:text-white transition-colors">Blog</Link></li>
              </ul>
            </div>
            
            <div>
              <h3 className="text-lg font-semibold mb-4">Contact</h3>
              <ul className="space-y-2">
                <li className="flex items-center space-x-2">
                  <Mail size={16} />
                  <a href="mailto:info@hotelchatai.com" className="text-gray-300 hover:text-white transition-colors">
                    info@hotelchatai.com
                  </a>
                </li>
                <li className="flex items-center space-x-2">
                  <Phone size={16} />
                  <a href="tel:+11234567890" className="text-gray-300 hover:text-white transition-colors">
                    +1 (123) 456-7890
                  </a>
                </li>
                <li className="flex items-center space-x-4 mt-4">
                  <a href="#" className="text-gray-300 hover:text-white transition-colors">
                    <Twitter size={20} />
                  </a>
                  <a href="#" className="text-gray-300 hover:text-white transition-colors">
                    <Facebook size={20} />
                  </a>
                  <a href="#" className="text-gray-300 hover:text-white transition-colors">
                    <Instagram size={20} />
                  </a>
                </li>
              </ul>
            </div>
          </div>
          
          <div className="mt-8 pt-6 flex flex-col md:flex-row justify-center items-center">
            <p className="text-sm text-slate-500 me-4">
              &copy; {new Date().getFullYear()} Lobier AI. All rights reserved.
            </p>
            <div className="flex items-center space-y-2">
              <div className="flex space-x-4">
                <Link to="/login" className="text-sm text-slate-500 hover:text-white transition-colors">
                  Login
                </Link>
                <Link to="/contact" className="text-sm text-slate-500 hover:text-white transition-colors">
                  Contact Us
                </Link>
                <Link to="/privacy" className="text-sm text-slate-500 hover:text-white transition-colors">
                  Privacy Policy
                </Link>
                <Link to="/terms" className="text-sm text-slate-500 hover:text-white transition-colors">
                  Terms of Service
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
